import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { useEffect } from 'react';
import TopMenuStore from '@src/business-components/top-menu/store';
import MechaPosterStore from './components/mecha-poster/store';
import ArmedIntroductionStore from './components/armed-introduction/store';
import MoreMechaStore from './components/more-mecha/store';
import useModal from '@src/utils/hooks/use-modal';
import MechaInfoModalStore from './components/mecha-info-modal/store';
import MechaInfoModal from './components/mecha-info-modal';
import MechaInfoTextModalStore from './components/mecha-info-text-modal/store';
import MechaInfoTextModal from './components/mecha-info-text-modal';
import { autobind } from 'core-decorators';
import Toast from '@src/business-components/common-message';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';
import { jumpPage } from '@src/utils/common-util';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const pageLocalesData = getPageLocalesData();

class MechaStore extends BaseStore {
  // 当前机甲id
  @observable mechaId;
  // 当前机甲信息
  @observable mechaInfoMsg;
  // @弹窗信息
  @observable mechaInfoModal;
  // 是否文本
  @observable isTextMEcha = true;
  // 是否渲染
  @observable isActive = false;

  /**
   * 页面的配置数据
   */
  @observable pageData;

  // 机甲信息弹窗
  mechaInfoModalStore = new MechaInfoModalStore();
  // 机甲信息弹窗
  mechaInfoTextModalStore = new MechaInfoTextModalStore();
  // 导航栏
  topMenuStore = new TopMenuStore({});
  // 机甲立绘
  mechaPosterStore = new MechaPosterStore({
    mechaStore: this,
    openMechaInfo: () => {
      if (this.mechaInfoModal[0].type_option === '2') {
        this.mechaInfoModalStore.mecha_history_image = this.mechaInfoModal[0].background_image_mo;
        this.mechaInfoModalStore.isOpen = true;
        this.mechaInfo.open();
      } else if (this.mechaInfoModal[0].type_option === '1') {
        this.mechaInfoTextModalStore.mechaInfo = this.mechaInfoModal[0];
        this.mechaInfoTextModalStore.mechaInfo.name = this.mechaInfoMsg.mecha_name;
        this.mechaInfoTextModalStore.isOpen = true;
        this.mechaInfoText.open();
      } else {
        Toast.info(`${pageLocalesData.global.comming_soon}`);
      }
    }
  });
  Lang() {
    if (getLanguageByPath() === 'zh-Hant') {
      return 'tc';
    } else {
      return getLanguageByPath();
    }
  }
  // 武装介绍
  armedIntroductionStore = new ArmedIntroductionStore({ mechaStore: this });
  // 更多机甲
  moreMechaStore = new MoreMechaStore({
    mechaStore: this,
    clickCback: () => {
      this.armedIntroductionStore.clickTab(0);
    }
  });

  goBack() {
    // IS_DEV_ENV  DEPLOY_ENV
    if (!IS_DEV_ENV) {
      const url = 'mecha-list.html';
      jumpPage(url, '#/');
    } else {
      this.redirect('/mecha-list');
    }
  }

  /**
   * 初始化页面信息
   * @param {*} mechaId 机甲id
   */
  @autobind
  init(mechaId, mechasMsg) {
    if (mechaId && mechasMsg) {
      this.mechaId = mechaId;
      const foundMecha = mechasMsg.find(item => item.mecha_id === mechaId);
      if (foundMecha) {
        this.mechaInfoMsg = foundMecha;
      }
    }
    //console.log('this.mechaInfoMsg', this.mechaInfoMsg);
    //console.log('mechaId', mechaId);

    if (!mechaId || !this.mechaInfoMsg) {
      // Toast.info('检查到机兵编号有误!!!');
      // this.redirect('/');
      return false;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  use() {
    super.use();
    const mecha_id = this.$routeMatch.query.mecha_id;
    const data = useFunLinkPageData();
    //console.log(data, 'data');

    useEffect(
      () => {
        if (!data || !mecha_id) {
          return;
        }
        this.mechaInfoModal = data?.mechaInfo.filter(item => item.mecha_id === mecha_id);

        // 整合机甲和机甲武器的数据
        let mechasMsg = data?.mecha_list.map(itemA => {
          let matchingB = data?.mecha_weapon.filter(itemB => itemB?.weapon_id === itemA?.mecha_id);
          // 将a项和对应的b项合并
          return { ...itemA, weapon: matchingB };
        });
        this.pageData = data?.mecha_data;
        this.moreMechaStore.more_mecha_list = data?.mecha_list.filter(item => item.mecha_id !== mecha_id);
        this.init(mecha_id, mechasMsg);
      },
      [data, mecha_id]
    );

    this.mechaInfo = useModal(MechaInfoModal, { store: this.mechaInfoModalStore });
    this.mechaInfoText = useModal(MechaInfoTextModal, { store: this.mechaInfoTextModalStore });
    useMount(async () => {
      // this.mechaInfoTextModalStore.isOpen = true;
      // this.mechaInfoText.open();
      // TODO: 初始化页面信息
    });
  }
}

export default MechaStore;
